// Copyright (c) 2018 Deere & Company

import * as busyCounter from './busy-counter';
import {
    getAllAvailableColumns,
    getAvailableColumns
} from '../services/available-excel-columns';
import actions from '../actions-list';
import {getExcelLayouts} from '../repositories';
import {updateSelectedExcelLayout} from './selected-excel-layout';

export const readExcelLayouts = listId =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const excelLayouts = await getExcelLayouts(listId);

            const selectedExcelLayout = excelLayouts.find(layout => layout.isDefault);

            dispatch({
                excelLayouts,
                listId,
                type: actions.UPDATE_EXCEL_LAYOUTS
            });

            if (selectedExcelLayout) {

                updateSelectedExcelLayout(selectedExcelLayout, listId)(dispatch);

                dispatch({
                    availableColumns: getAvailableColumns(listId, selectedExcelLayout.columns),
                    type: actions.UPDATE_EXCEL_LAYOUT_MODAL_AVAILABLE_COLUMNS
                });

            } else {

                dispatch({
                    availableColumns: getAllAvailableColumns(listId),
                    type: actions.UPDATE_EXCEL_LAYOUT_MODAL_AVAILABLE_COLUMNS
                });

            }

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/shared/action-creators/read-excel-layouts.js